import React from "react";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: React.ReactNode;
  variant?: "split" | "centered";
  tagline?: string;
}

const AuthLayout = ({
  children,
  variant = "split",
  tagline = "The community marketing platform for modern brands."
}: AuthLayoutProps) => {
  if (variant === "centered") {
    return (
      <div className="min-h-[100dvh] flex flex-col items-center justify-center bg-white px-4">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <img src="/ernest-wordmark.png" alt="ernest" className="h-8 mx-auto" />
          </div>
          {children}
        </div>
      </div>);

  }

  return (
    <div className="min-h-[100dvh] flex overflow-hidden relative">
      {/* Mobile logo — top left, links home. Matches HomePage header's h-16 + items-center exactly. */}
      <div className="lg:hidden absolute inset-x-0 top-0 h-16 px-6 flex items-center pointer-events-none z-10">
        <Link to="/" className="pointer-events-auto hover:opacity-80 transition-opacity">
          <img src="/ernest-wordmark.png" alt="ernest" className="h-[28px] ml-[-2px] md:h-9 md:ml-0" />
        </Link>
      </div>

      {/* Left panel — match onboarding branding */}
      <div className="hidden lg:flex lg:w-[45%] relative overflow-hidden bg-foreground flex-col justify-between p-12">
        <div className="pointer-events-none absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-[#584dff] opacity-40 blur-[120px]" />
        <div className="pointer-events-none absolute -bottom-32 -right-20 w-[460px] h-[460px] rounded-full bg-[#DEFF00] opacity-20 blur-[140px]" />
        <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '24px 24px' }} />

        <Link to="/" className="relative z-10 hover:opacity-80 transition-opacity">
          <img src="/ernest-wordmark-white.png" alt="ernest" className="h-9" />
        </Link>
        <div className="relative z-10 flex items-center justify-between text-xs text-background/40">
          <span>© {new Date().getFullYear()} Ernest</span>
        </div>
      </div>

      {/* Right panel — form */}
      <div className="flex-1 flex items-center justify-center bg-white px-6 py-20 lg:py-12">
        <div className="w-full max-w-[400px]">{children}</div>
      </div>
    </div>);

};

export default AuthLayout;
